import { createContext } from "react";

const LoaderContext = createContext();
const AuthContext = createContext();
const CurrencyContext = createContext();
const TripContext = createContext();
export { LoaderContext, AuthContext, CurrencyContext, TripContext };
